<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  @if (!isBulkEdit) {
    <div class="d-flex flex-column gap-2">
      <div class="fw-bold">
        {{ 'admin.generalRatesRuleEngine.entityType' | translate }}
        <span class="text-danger">*</span>
      </div>
      <gstar-entity-types-combobox
        [required]="true"
        [value]="selectedEntityTypeValue"
        [onlyActives]="true"
        [onlyNonDefaults]="true"
        [filterByJurisdiction]="false"
        [placeholder]="'portfolio.securities.investingEntity' | translate"
        [disabled]="isEdit"
        (selectEntityType)="selectEntityType($event)"
        (clearEntityType)="clearEntityType()" />
    </div>

    <div class="d-flex flex-column gap-2">
      <div class="fw-bold">
        {{ 'admin.generalRatesRuleEngine.investmentJurisdictions' | translate }}
        <span class="text-danger">*</span>
      </div>
      <gstar-investment-jurisdiction-combobox
        #investmentJurisdictionComp
        [value]="selectedInvestmentJurisdictionValue"
        [required]="true"
        [onlyActives]="true"
        [disabled]="isEdit"
        [useCountryMaterialFilter]="false"
        (clearInvestmentJurisdiction)="clearInvestmentJurisdiction()"
        (selectInvestmentJurisdiction)="addInvestmentJurisdiction($event)" />
    </div>

    <div class="d-flex flex-column gap-2">
      <div class="fw-bold">
        {{ 'admin.generalRatesRuleEngine.securityTypes' | translate }}
        <span class="text-danger">*</span>
      </div>
      <gstar-security-types-combobox
        #securityTypesComp
        [value]="selectedSecurityTypeValue"
        [required]="true"
        [disabled]="isEdit"
        [allowedSecurityTypeNames]="allowedSecurityTypeNames"
        (selectSecurityType)="addSecurityType($event)"
        (clearSecurityType)="clearSecurityType()" />
    </div>

    @if (showIncomeTypeSection) {
      <div class="d-flex flex-column gap-2">
        <div class="fw-bold">
          {{ 'admin.generalRatesRuleEngine.incomeType' | translate }}
          <span class="text-danger">*</span>
        </div>
        <gstar-income-types-combobox
          #incomeTypesComp
          [value]="selectedIncomeTypeValue"
          [securityTypeId]="selectedSecurityTypeId"
          [disabled]="isEdit"
          (selectIncomeType)="addIncomeType($any($event))"
          (clearIncomeType)="clearIncomeType()" />
      </div>
    }
  } @else {
    <p class="mb-0">
      {{
        'admin.grid.bulkEditGeneralRatesRuleEngineDescription'
          | translate: { count: bulkItems.length }
      }}
    </p>
  }

  @if (showRateAndExplanationSection) {
    <ap-field
      [title]="'admin.generalRatesRuleEngine.rate' | translate"
      [required]="!isBulkEdit && ratesList.length === 0"
      [error]="!!form.get('rate')?.touched && !!form.get('rate')?.errors">
      <input
        appkit-field
        formControlName="rate"
        type="text"
        inputmode="decimal"
        autocomplete="off"
        min="0"
        max="100"
        step="0.01"
        [disabled]="isEdit && editingRateIndex === null"
        (keydown)="preventInvalidRateKeys($event)"
        (input)="sanitizeRateInput($event)"
        (keydown.enter)="addRateToList($event)" />
    </ap-field>
    @if (ratesList.length > 0) {
      <div class="d-flex flex-wrap gap-2">
        @for (rateItem of ratesList; track $index; let i = $index) {
          <span
            class="badge d-inline-flex align-items-center gap-1 fw-normal"
            [class.text-bg-primary]="editingRateIndex === i"
            [class.text-bg-secondary]="editingRateIndex !== i"
            style="cursor: pointer"
            tabindex="0"
            (click)="selectRateForEdit(i)"
            (keydown.enter)="selectRateForEdit(i)"
            (keydown.space)="selectRateForEdit(i)">
            {{ rateItem }}
            <button
              type="button"
              class="btn-close btn-close-white"
              style="font-size: 0.5em"
              (click)="$event.stopPropagation(); removeRateFromList(i)"
              aria-label="Remove rate"></button>
          </span>
        }
      </div>
    }

    <div class="d-flex flex-column gap-2">
      <div class="fw-bold">
        {{ 'admin.generalRatesRuleEngine.explanation' | translate }}
        @if (!isBulkEdit) {
          <span class="text-danger">*</span>
        }
      </div>

      <div class="d-flex flex-column gap-1">
        <div style="position: relative">
          <div
            class="w-100 border rounded p-2 overflow-auto explanation-display"
            style="
              min-height: 8rem;
              max-height: 12rem;
              padding-right: 2.5rem;
              background: white;
              cursor: default;
            "
            [class.border-danger]="
              form.get('explanation')?.touched &&
              form.get('explanation')?.errors
            "
            [innerHTML]="
              explanationHtml || form.get('explanation')?.value
                | blankLinks
                | safe: 'html'
            "></div>
          <input type="hidden" formControlName="explanation" />
          <ap-button
            style="position: absolute; top: 0.25rem; right: 0.25rem"
            btnType="text"
            icon="edit-outline"
            [compact]="true"
            ap-tooltip
            tooltipContent="Text Editor"
            (onClick)="openExplanationEditor()" />
        </div>
        <div class="ap-field-suggestion">
          {{
            'suggestions.charactersRemaining'
              | translate
                : {
                    count:
                      explanationMaxLength -
                      (form.get('explanation')?.value?.length || 0),
                  }
          }}
        </div>
        @if (
          form.get('explanation')?.touched &&
          form.get('explanation')?.errors?.['required']
        ) {
          <div class="ap-field-validation-error">
            {{ 'formValidations.required' | translate }}
          </div>
        }
        @if (
          form.get('explanation')?.touched &&
          form.get('explanation')?.errors?.['maxLength']
        ) {
          <div class="ap-field-validation-error">
            {{
              'formValidations.maxLengthExceeded'
                | translate: { maxLength: explanationMaxLength }
            }}
          </div>
        }
      </div>
    </div>
  }
</form>
